import formName from 'constants/formName'
import { actions } from 'data'
import { WhitelistAddressStepType } from 'data/types'
import { put } from 'redux-saga/effects'

export const goToStep = function* (step: WhitelistAddressStepType) {
  yield put(actions.form.change(formName.WHITELIST_ADDRESS, 'step', step))
}
